export default "__VITE_ASSET__1ab3bcc0__"